export default __webpack_public_path__ + "static/media/explorar-icon.3360f529.svg";